import * as point from "../api/point";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import pointActions from "../slices/pointSlice";
import { ErrorLogic } from "../../components/hooks/authFunc";

//포인트 - 포인트 교환 페이지 리스트
function* requestFetchPointAffiliateList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(point.requestPointAffiliateList, params);
  if (response) {
    yield put(pointActions.actions.fetchPointAffiliateListSuccess(response));
  } else {
    yield put(pointActions.actions.fetchPointAffiliateListFailure(err));
    yield ErrorLogic(err.response);
  }
}

//포인트 - 포인트 교환 - 연동하기
function* requestFetchPointAffiliateLink(payload) {
  const params = payload.payload;
  const { response, err } = yield call(point.requestPointAffiliateLink, params);
  if (response) {
    yield put(pointActions.actions.fetchPointAffiliateLinkSuccess(response));
  } else {
    yield put(pointActions.actions.fetchPointAffiliateLinkFailure(err));
    yield ErrorLogic(err.response);
  }
}

//포인트 - 포인트교환 페이지 진입
function* requestFetchPointLookUp(payload) {
  const params = payload.payload;
  const { response, err } = yield call(point.requestPointLookUp, params);
  if (response) {
    yield put(pointActions.actions.fetchPointLookUpSuccess(response));
  } else {
    yield put(pointActions.actions.fetchPointLookUpFailure(err));
    yield ErrorLogic(err.response);
  }
}

//포인트 - 포인트교환 실행
function* requestFetchPointExchange(payload) {
  const params = payload.payload;
  const { response, err } = yield call(point.requestPointExChange, params);
  if (response) {
    yield put(pointActions.actions.fetchPointExChangeSuccess(response));
  } else {
    yield put(pointActions.actions.fetchPointExChangeFailure(err));
    yield ErrorLogic(err.response);
  }
}

export default function* watchPoint() {
  yield takeLatest(
    pointActions.actions.fetchPointAffiliateList,
    requestFetchPointAffiliateList
  );
  yield takeLatest(
    pointActions.actions.fetchPointAffiliateLink,
    requestFetchPointAffiliateLink
  );
  yield takeLatest(
    pointActions.actions.fetchPointLookUp,
    requestFetchPointLookUp
  );
  yield takeLatest(
    pointActions.actions.fetchPointExchange,
    requestFetchPointExchange
  );
}
